import React from 'react';

const Logo = () => {
    return (
        <svg height="40" viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Elegant interconnected nodes representing neural network/synapse */}
            <defs>
                <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="var(--color-primary)" />
                    <stop offset="100%" stopColor="var(--color-teal-hover)" />
                </linearGradient>
            </defs>

            {/* Three elegant interconnected circles */}
            <circle cx="20" cy="20" r="8" fill="url(#logoGradient)" opacity="0.9" />
            <circle cx="50" cy="20" r="8" fill="url(#logoGradient)" opacity="0.9" />
            <circle cx="80" cy="20" r="8" fill="url(#logoGradient)" opacity="0.9" />

            {/* Connecting lines */}
            <line x1="28" y1="20" x2="42" y2="20" stroke="url(#logoGradient)" strokeWidth="2" strokeLinecap="round" />
            <line x1="58" y1="20" x2="72" y2="20" stroke="url(#logoGradient)" strokeWidth="2" strokeLinecap="round" />

            {/* Elegant text */}
            <text x="100" y="26" fontSize="22" fontWeight="600" fill="var(--color-text)" fontFamily="system-ui, -apple-system, sans-serif">
                Synapse
            </text>
        </svg>
    );
};

export default Logo;
